import React from 'react';
import {useHistory, useLocation} from "react-router-dom";
import {formatDate, MOMENT_FORMAT_DATE_DMYHM_DOTS} from "../../../functions/formatters";
import {actCRUD} from '../../../http';
import CRUDTable from "../CRUDTable";
import {actsFilterFields, actsSearchFields} from "../../../sections/Filters/ActsFilters";
import {State} from "../../../functions";
import { addRange } from '../../../functions/linqSimulation';
import { requestStateIds } from '../../../models/requestStateIds';
import useReload from '../../../hooks/useReload';
import { appendRequestRollbackColumn, isPaidActRow } from '../requestRollbackColumn';

export default function ActCRUDTable({ extraQuery: extraQueryProp, ...props }) {
    const {push} = useHistory()
    const {pathname} = useLocation()
    let isDSEK = `${pathname[1].toUpperCase()}${pathname.substring(2)}`.includes('DSEK')
    const { reload, reloadValue: localReloadValue } = useReload();

    const columns = [
        {title: "№", dataIndex: 'id', key: 'id'},
        {
            title: "Создано",
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: row => formatDate(row, MOMENT_FORMAT_DATE_DMYHM_DOTS)
        },
        {title: "Номер", dataIndex: 'number', key: 'number'},
        {
            title: "Наименование объекта", dataIndex: 'test', key: 'test', render: (unknown, row) => {
                const data = typeof row.data === 'string' ? JSON.parse(row.data) : {}
                return data?.object?.value?.name ? data.object.value.name :
                    <span style={{color: "gray"}}>Не задан</span>
            }
        },        
    ];

    if (props.readonly) {
        columns.push({
            title: "Форма",
            dataIndex: 'form',
            key: 'form',
            render: (unknown, row) => row.form ? row.form.name : <span style={{color: "gray"}}>Не задан</span>
        });
    }

    addRange(columns, [
        {
            title: "Филиал",
            dataIndex: 'filial',
            key: 'filial',
            render: (unknown, row) => row.filial ? row.filial.name : <span style={{color: "gray"}}>Не задан</span>
        },
        {
            title: "Районное отделение",
            dataIndex: 'filialDivision',
            key: 'filialDivision',
            render: (unknown, row) =>
                row.filialDivisionId ? (
                    row.filialDivision?.name ||
                    row.filialDivision?.Name ||
                    `ID: ${row.filialDivisionId}`
                ) : (
                    <span style={{ color: "gray" }}>Не задано</span>
                ),
        },
        {
            title: "Исполнитель", dataIndex: 'test', key: 'test', render: (unknown, row) => {
                switch (row.state?.code) {
                    case 'ProbeSelection':
                        return row.responsibleForProbes ? row.responsibleForProbes.fullName : ''
                    case 'Research':
                        return row.performer ? row.performer.fullName : ''
                    case 'Completed':
                        return row.performer ? row.performer.fullName : ''
                    case 'Created':
                        return ''
                    case 'Processing':
                        return row.responsible ? row.responsible.fullName : ''
                    case 'Declined':
                        return ''
                    default:
                        return ''
                }
            }
        },
        {
            title: "Статус", dataIndex: 'test', key: 'test', render: (unknown, row) => {

                if (row.state?.code.toLowerCase() === State.Processsing && row.number[0] === '2') {
                    return 'Отправлен в НЦЭ'
                }

                if (row.state) {
                    return row.state.name
                } else {
                    return <span style={{color: "gray"}}>Не задан</span>
                }
            }
        },
    ]);

    if (!isDSEK) {
        appendRequestRollbackColumn(columns, actCRUD, {
            reload,
            isRowEligible: isPaidActRow,
        });
    }

    const searchFields = [
        ...actsSearchFields,
    ];

    const filterFields = [
        ...actsFilterFields
    ];

    const mergedExtraQuery = {
        ...(extraQueryProp || {}),
        includes: [
            ...new Set([
                "FilialDivision",
                ...((extraQueryProp && extraQueryProp.includes) || []),
            ]),
        ],
    };

    return <CRUDTable
        search={actCRUD.search}
        columns={columns}
        filterFields={filterFields}
        searchFields={searchFields}
        onClickDetailsButton={!props.readonly ? (id) => push(`${pathname.replace('DSEK', '')}Detail/${id}?orderType=${isDSEK ? 2 : 1}`) : null}
        onClickCreateButton={!props.readonly ? () => push(`${pathname.replace('DSEK', '')}Detail/new?orderType=${isDSEK ? 2 : 1}`) : null}
        reloadValue={props.reloadValue ?? localReloadValue}
        rowClassNameHandler={(record) => {
            if (record.stateId === requestStateIds.declined) {
              return 'banned'
            }
        }}
        {...props}
        extraQuery={mergedExtraQuery}
    />
}
